import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Card, Row, Col, Form, Button } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import axios from "axios";

const HelpIcon = ({ text }) => (
    <Tooltip title={text} arrow placement="right">
        <InfoOutlinedIcon style={{ marginLeft: "6px", cursor: "pointer", color: "#0d6efd" }} fontSize="small" />
    </Tooltip>
);


function AddLeaveMaster() {
    const userData = sessionStorage.getItem('user');
    const userObj = userData ? JSON.parse(userData) : {};
    const [editId, setEditId] = useState(null);
    const routeLocation = useLocation();
    const navigate = useNavigate();
    const [weekendDaysLimit, setWeekendDaysLimit] = useState("");

    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    const [form, setForm] = useState({
        leave_description: "",
        leave_code: "",
        yearly_accumulation: null,   // number
        consider_holidays: "",    // 'Y' | 'N'
        combination_of_leaves: "",
        consider_half_day: "",
        max_days_to_avail: null,     // number
        max_accumulation: null,      // number
        consider_encashment: "",
        consider_lapse: "",
        max_carryforward: null,      // number
        monthlyfrequency: "",      // number (1..12)
        monthly_accumulation: null,  // number (int as backend expects)
        restrict_holidays: "",
        restrict_weekends: "",

        is_active: "A"
    });





    useEffect(() => {
        if (routeLocation.state?.leaveData) {
            const leaveData = routeLocation.state.leaveData;
            setForm(leaveData);
            setEditId(leaveData.leave_id);

            
            window.history.replaceState({}, document.title);
        }
    }, [routeLocation]);

    const handleInputChange = (e) => {
        const { id, value } = e.target;

        setForm(prev => {
            const updated = { ...prev };

            const numericIds = new Set([
                "yearly_accumulation", "max_days_to_avail", "max_accumulation",
                "max_carryforward", "monthlyfrequency", "monthly_accumulation"
            ]);

            if (numericIds.has(id)) {
                updated[id] = value === "" ? 0 : Number(value);
            } else {
                updated[id] = value;
            }

          
            if (id === "yearly_accumulation" || id === "monthlyfrequency") {
                const yearly = Number(updated.yearly_accumulation) || 0;
                const freq = Number(updated.monthlyfrequency) || 0;
                if (yearly > 0 && freq > 0) {
                 
                    const per = yearly / (12 / freq);
                    updated.monthly_accumulation = Math.round(per); 
                } else {
                    updated.monthly_accumulation = 0;
                }
            }

            return updated;
        });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const convertToYN = (value) => {
            if (value === 'Yes') return 'Y';
            if (value === 'No') return 'N';
            return value;
        };

        if ((form.restrict_weekends === "Y" || form.restrict_weekends === "Yes") && !weekendDaysLimit) {
            toast.error("Please enter number of weekend days allowed.");
            return;
        }

        const formData = {
            leave_description: form.leave_description || "",
            leave_code: form.leave_code || "",
            yearly_accumulation: form.yearly_accumulation || 0,
            consider_holidays: convertToYN(form.consider_holidays),
            combination_of_leaves: convertToYN(form.combination_of_leaves),
            consider_half_day: convertToYN(form.consider_half_day),
            max_days_to_avail: form.max_days_to_avail || 0,
            max_accumulation: form.max_accumulation || "",
            consider_encashment: convertToYN(form.consider_encashment),
            consider_lapse: convertToYN(form.consider_lapse),
            max_carryforward: form.max_carryforward || 0,
            monthlyfrequency: form.monthlyfrequency || 0,
            monthly_accumulation: form.monthly_accumulation || 0,
            restrict_holidays: convertToYN(form.restrict_holidays),
            restrict_weekends: convertToYN(form.restrict_weekends),
            weekend_days_limit: weekendDaysLimit || 0,

            school_id: userObj.school_id,
            action: editId !== null ? "UPDATE" : "CREATE",
        };
        console.log(formData);
        setForm({
            leave_description: "",
            leave_code: "",
            yearly_accumulation: "",
            consider_holidays: "",
            combination_of_leaves: "",
            consider_half_day: "",
            max_days_to_avail: "",
            max_accumulation: "",
            consider_encashment: "",
            consider_lapse: "",
            max_carryforward: "",
            monthlyfrequency: "",
            monthly_accumulation: "",
            restrict_holidays: "",
            restrict_weekends: "",
            school_id: "",
        });

        if (editId !== null) {
            formData.leave_id = editId;
        }

        try {
            const response = await axios.post(baseUrl + "/LeaveMaster/", formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            console.log("API Response" + response);

            toast.success(editId ? "Record Updated Successfully" : "Record Added Successfully");



        } catch (error) {
            console.error("Error submitting data:", error.response?.data || error.message);
            if (error.response?.data?.error?.includes("already exists")) {
                toast.error("Record already exists");
            }
            else if (error.response?.data?.error?.includes("max carryforward cannot be greater than max accumulation")) {

                toast.error("Max carryforward cannot be greater than max accumulation");
            }
            else if (error.response?.data?.error?.includes("yearly accumulation cannot be greater than max accumulation")) {

                toast.error("Yearly accumulation cannot be greater than max accumulation");
            }
            else if (error.response?.data?.error?.includes("max days to avail cannot be greater than max accumulation")) {

                toast.error("Max days to avail cannot be greater than max accumulation");
            }
            else {
                toast.error("Unexpected error occurred");
            }
        }
    };

    return (



        <div className='pageBody'>
            <ToastContainer />
            <Container fluid>

                <div className=''>
                    <Card>

                        <Card.Body>
                            <form className="" onSubmit={handleSubmit}>

                                <div className=''>
                                    <Row>
                                        <Col xs={12}>
                                            <h6 className='commonSectionTitle'>Leave Type Details</h6>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>
                                                        Leave Type<span className='requiredStar'>*</span>
                                                        <HelpIcon text="Name of the leave type (e.g., Casual Leave, Sick Leave, etc.)." />
                                                    </Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        id="leave_description"
                                                        value={form.leave_description}
                                                        placeholder="Enter Leave Type"
                                                        maxLength={30}
                                                        onChange={(e) => {
                                                            let value = e.target.value;


                                                            if (value.startsWith(" ")) {
                                                                value = value.trimStart();
                                                            }


                                                            if (/^[A-Za-z\s]*$/.test(value)) {
                                                                handleInputChange({ target: { id: e.target.id, value } });
                                                            }
                                                        }}

                                                    />
                                                    <Form.Control.Feedback>Required</Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                        </Col>

                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>
                                                        Leave Code<span className='requiredStar'>*</span>
                                                        <HelpIcon text="Type of Leave Employee Applied For" />
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        required
                                                        id="leave_code"
                                                        value={form.leave_code}
                                                        maxLength={2}
                                                        placeholder="Enter Leave Code"
                                                        onChange={(e) => {
                                                            let value = e.target.value;


                                                            value = value.replace(/^\s+/, "");


                                                            value = value.replace(/[^A-Za-z]/g, "");


                                                            handleInputChange({
                                                                target: {
                                                                    id: "leave_code",
                                                                    value: value
                                                                }
                                                            });
                                                        }}
                                                    />
                                                    <Form.Control.Feedback>Required</Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                        </Col>


                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>
                                                        Max Accumulation<span className='requiredStar'>*</span>
                                                        <HelpIcon text="Specifies the maximum number of leave days an employee can accumulate over time. Once this limit is reached, no additional leave will be added until some is used." />
                                                    </Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        id="max_accumulation"
                                                        value={form.max_accumulation}
                                                        placeholder="Enter Max Accumulation"
                                                        maxLength={2}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (/^\d*$/.test(value)) {
                                                                handleInputChange(e);
                                                            }
                                                        }}
                                                    />
                                                    <Form.Control.Feedback>Required</Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                        </Col>

                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>
                                                        Max Days to Avail<span className='requiredStar'>*</span>
                                                        <HelpIcon text="Defines the maximum number of leave days an employee can take at one time for this leave type." />
                                                    </Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        id="max_days_to_avail"
                                                        value={form.max_days_to_avail}
                                                        placeholder="Enter Max Days to Avail"
                                                        maxLength={2}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (/^\d*$/.test(value)) {
                                                                handleInputChange(e);
                                                            }
                                                        }}
                                                    />
                                                    <Form.Control.Feedback>Required</Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>
                                                        Yearly Accumulation<span className='requiredStar'>*</span>
                                                        <HelpIcon text="Indicates the total number of leave days an employee earns or is credited with each year for this leave type." />
                                                    </Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        id="yearly_accumulation"
                                                        value={form.yearly_accumulation}
                                                        placeholder="Enter Yearly Accumulation"
                                                        maxLength={2}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (/^\d*$/.test(value)) {
                                                                handleInputChange(e);
                                                            }
                                                        }}
                                                    />
                                                    <Form.Control.Feedback>Required</Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>
                                                        Accumulation Frequency<span className='requiredStar'>*</span>
                                                        <HelpIcon text="Specifies how often leave is credited to the employee — for example, every month, every 3 months, or yearly." />
                                                    </Form.Label>
                                                    <Form.Select
                                                        required
                                                        id="monthlyfrequency"
                                                        value={form.monthlyfrequency}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="" disabled hidden>-- Select --</option>
                                                        {[...Array(12).keys()].map((num) => (
                                                            <option key={num + 1} value={num + 1}>
                                                                {num + 1}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                    <Form.Control.Feedback>Required</Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                        </Col>

                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>
                                                        Accumulation Value<span className='requiredStar'>*</span>
                                                        <HelpIcon text="Shows the number of leave days credited each time based on the selected accumulation frequency. This value is calculated automatically." />
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        id="monthly_accumulation"
                                                        value={form.monthly_accumulation}
                                                        // placeholder="Auto-calculated"
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>
                                                        Consider Holidays<span className='requiredStar'>*</span>
                                                        <HelpIcon text="Select ‘Yes’ if holidays falling within the leave period should be counted as part of the leave days; select ‘No’ to exclude holidays." />
                                                    </Form.Label>
                                                    <div>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Yes"
                                                            name="consider_holidays"
                                                            id="consider_holidays"
                                                            value="Y"
                                                            checked={form.consider_holidays === "Y" || form.consider_holidays === "Yes"}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="No"
                                                            name="consider_holidays"
                                                            id="consider_holidays"
                                                            value="N"
                                                            checked={form.consider_holidays === "N" || form.consider_holidays === "No"}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>
                                                    <Form.Control.Feedback>Required</Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                        </Col>
                                       
                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>
                                                        Combination of Leaves<span className='requiredStar'>*</span>
                                                        <HelpIcon text="Choose ‘Yes’ if this leave type can be combined with other leave types in a single application; choose ‘No’ to restrict it." />
                                                    </Form.Label>
                                                    <div>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Yes"
                                                            name="combination_of_leaves"
                                                            id="combination_of_leaves"
                                                            value="Y"
                                                            checked={form.combination_of_leaves === "Y" || form.combination_of_leaves === "Yes"}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="No"
                                                            name="combination_of_leaves"
                                                            id="combination_of_leaves"
                                                            value="N"
                                                            checked={form.combination_of_leaves === "N" || form.combination_of_leaves === "No"}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>
                                                    <Form.Control.Feedback>Required</Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                        </Col>

                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>
                                                        Consider Half Day<span className='requiredStar'>*</span>
                                                        <HelpIcon text="Select ‘Yes’ if employees are allowed to take this leave for a half day; select ‘No’ if only full-day leave is permitted." />
                                                    </Form.Label>
                                                    <div>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Yes"
                                                            name="consider_half_day"
                                                            id="consider_half_day"
                                                            value="Y"
                                                            checked={form.consider_half_day === "Y" || form.consider_half_day === "Yes"}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="No"
                                                            name="consider_half_day"
                                                            id="consider_half_day"
                                                            value="N"
                                                            checked={form.consider_half_day === "N" || form.consider_half_day === "No"}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>
                                                    <Form.Control.Feedback>Required</Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                        </Col>

                                        {/* // Restrict Holiday */}
                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>
                                                        Restrict Holidays<span className='requiredStar'>*</span>
                                                        <HelpIcon text="Select ‘Yes’ if any holiday occurring in the month should be treated as a loss of pay (LOP) for the employee; select ‘No’ to ignore holidays for LOP calculation." />
                                                    </Form.Label>
                                                    <div>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Yes"
                                                            name="restrict_holidays"
                                                            id="restrict_holidays"
                                                            value="Y"
                                                            checked={form.restrict_holidays === "Y" || form.restrict_holidays === "Yes"}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="No"
                                                            name="restrict_holidays"
                                                            id="restrict_holidays"
                                                            value="N"
                                                            checked={form.restrict_holidays === "N" || form.restrict_holidays === "No"}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>
                                                    <Form.Control.Feedback>Required</Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                        </Col>
                                        {/* Restrict Sat month */}
                                      <Col xs={12} md={6} lg={4} xxl={3}>
  <div className="commonInput">
    <Form.Group>
      <Form.Label>
        Restrict Weekends<span className="requiredStar">*</span>
        <HelpIcon text="Select ‘Yes’ to apply loss of pay (LOP) when an employee takes leave adjoining weekends. For example, if the employee applies leave on Saturday, Sunday and Monday will also be considered as leave (LOP or paid leave, as per rules)." />
      </Form.Label>

      <div>
        <Form.Check
          inline
          type="radio"
          label="Yes"
          name="restrict_weekends"
          value="Y"
          checked={form.restrict_weekends === "Y" || form.restrict_weekends === "Yes"}
          onChange={(e) => {
            setForm((prev) => ({ ...prev, restrict_weekends: "Y" }));
            setWeekendDaysLimit("2"); // ✅ default = 2
          }}
          required
        />

        <Form.Check
          inline
          type="radio"
          label="No"
          name="restrict_weekends"
          value="N"
          checked={form.restrict_weekends === "N" || form.restrict_weekends === "No" }
          onChange={(e) => {
            setForm((prev) => ({ ...prev, restrict_weekends: "N" }));
            setWeekendDaysLimit(""); // clear when “No”
          }}
          required
        />
      </div>

      {/* ✅ Show number input only when Yes is selected */}
      {/* ✅ Show number input if 'Yes' or 'Y' */}
{(form.restrict_weekends === "Y" || form.restrict_weekends === "Yes") && (
  <div className="mt-2">
    <Form.Label>Enter number of weekend days allowed:</Form.Label>
    <Form.Control
      type="number"
      min="1"
      id="weekend_days_limit"
      className="w-20"
      value={weekendDaysLimit || "2"}
      placeholder="Enter number"
      onChange={(e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) setWeekendDaysLimit(value);
      }}
    />
  </div>
)}


      <Form.Control.Feedback>Required</Form.Control.Feedback>
    </Form.Group>
  </div>
</Col>



                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>
                                                        Consider Encashment<span ></span>
                                                    </Form.Label>
                                                    <div>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Yes"
                                                            name="consider_encashment"
                                                            id="consider_encashment"
                                                            value="Y"
                                                            checked={form.consider_encashment === "Y" || form.consider_encashment === "Yes"}
                                                            onChange={handleInputChange}

                                                        />
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="No"
                                                            name="consider_encashment"
                                                            id="consider_encashment"
                                                            value="N"
                                                            checked={form.consider_encashment === "N" || form.consider_encashment === "No"}
                                                            onChange={handleInputChange}

                                                        />
                                                    </div>
                                                </Form.Group>
                                            </div>
                                        </Col>

                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>
                                                        Consider Lapse<span ></span>
                                                    </Form.Label>
                                                    <div>
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="Yes"
                                                            name="consider_lapse"
                                                            id="consider_lapse"
                                                            value="Y"
                                                            checked={form.consider_lapse === "Y" || form.consider_lapse === "Yes"}
                                                            onChange={handleInputChange}

                                                        />
                                                        <Form.Check
                                                            inline
                                                            type="radio"
                                                            label="No"
                                                            name="consider_lapse"
                                                            id="consider_lapse"
                                                            value="N"
                                                            checked={form.consider_lapse === "N" || form.consider_lapse === "No"}
                                                            onChange={handleInputChange}

                                                        />
                                                    </div>
                                                </Form.Group>
                                            </div>
                                        </Col>

                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>
                                                        Max Carryforward
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        id="max_carryforward"
                                                        value={form.max_carryforward}
                                                        placeholder="Enter Max Carryforward"
                                                        maxLength={2}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (/^\d*$/.test(value)) {
                                                                handleInputChange(e);
                                                            }
                                                        }}
                                                    />
                                                </Form.Group>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="d-flex justify-content-between mt-3">
                                    <div>
                                        <Button
                                            type="button"
                                            variant="primary"
                                            o className="btn-info clearBtn"
                                            onClick={() => setForm({
                                                leave_description: "",
                                                leave_code: "",
                                                yearly_accumulation: "",
                                                consider_holidays: "",
                                                combination_of_leaves: "",
                                                consider_half_day: "",
                                                max_days_to_avail: "",
                                                max_accumulation: "",
                                                consider_encashment: "",
                                                consider_lapse: "",
                                                max_carryforward: "",
                                                monthlyfrequency: form.monthlyfrequency || 0,          // ✅ send to backend
                                                monthly_accumulation: form.monthly_accumulation || 0,
                                                restrict_holidays: "",
                                                restrict_weekends: "",
                                                school_id: "",
                                            })}
                                        >
                                            Reset
                                        </Button>
                                    </div>
                                    <div>
                                        <Button
                                            type="button"
                                            variant="primary"
                                            className="btn-danger secondaryBtn me-2"
                                            onClick={() => window.history.back()}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="primary"
                                            className="btn-success primaryBtn"
                                        >
                                            Submit
                                        </Button>
                                    </div>
                                </div>
                            </form>
                        </Card.Body>
                    </Card>
                </div>
            </Container>


        </div>

    );
}

export default AddLeaveMaster;